// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.4);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
  z-index: 1000;
  overflow-y: auto;
}

.modal-container {
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-lg);
  position: relative;
  width: 600px;
  margin: auto 0;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  background: var(--bg);
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: var(--text-secondary);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.close-button:hover {
  background-color: var(--danger-light);
  color: var(--danger);
}

.modal-overlay.open {
  opacity: 1;
  visibility: visible;
}

.modal-button-div {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-top: 20px;
}

.modal-button-div .close {
  padding: 8px 20px;
  border-radius: var(--radius-sm);
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-weight: 500;
  transition: all var(--transition-fast);
}

.modal-button-div .close:hover {
  background-color: var(--bg);
  border-color: var(--text-muted);
}

.modal_title {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mEAAmE;EACnE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 40px 20px;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.modal-container {\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n  width: 600px;\n  margin: auto 0;\n}\n\n.close-button {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: var(--bg);\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: var(--text-secondary);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.close-button:hover {\n  background-color: var(--danger-light);\n  color: var(--danger);\n}\n\n.modal-overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-button-div {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: start;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.modal-button-div .close {\n  padding: 8px 20px;\n  border-radius: var(--radius-sm);\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-weight: 500;\n  transition: all var(--transition-fast);\n}\n\n.modal-button-div .close:hover {\n  background-color: var(--bg);\n  border-color: var(--text-muted);\n}\n\n.modal_title {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
